import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import TopLink from './TopLink.styled';
import EirLogOut from '../../eir-logout/EirLogOut';
import { getCookie } from '../../../hooks/useCookie';
import RootContext from '../../../../util/root.context';
import NotificationBanner from '../../eir-notification-banner/NotificationBanner';
import {
  getLocalStorageWithPrefix,
  setLocalStorageWithPrefix,
  getLocalStorage,
} from '../../../hooks/useLocalStorage';
import { getCartInfo } from '../../eir-cart/cart.util';

const { publicRuntimeConfig } = getConfig();

const TopNavLink = ({ styles, links, leftLink = false }) => {
  const theme = useTheme();
  const router = useRouter();
  const { state, dispatch } = useContext(RootContext);
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const loggedInCustomer = getCookie('customer_Name');
    if (loggedInCustomer) {
      dispatch({ type: 'ENABLE_LOGOUT', payload: true });
    }
  }, [state?.enableLogout]);

  const handleLogin = () => {
    dispatch({ type: 'DISPLAY_LOGIN', payload: true });
  };
  useEffect(() => {
    const cartInfo = getCartInfo(state.cart);
    setCartCount(cartInfo.numberOfOffers + cartInfo.numberOfDevices);
  }, [state?.updateContext]);

  useEffect(() => {
    const showLogin = getLocalStorageWithPrefix('ION_EXISTING_CUSTOMER') === 'false';
    if (router.asPath === '/shop/mobile' || router.asPath === '/shop/mobile/handsets') {
      if (showLogin) {
        dispatch({ type: 'ENABLE_LOGIN_BUTTON', payload: true });
      }
    }
  }, [state?.loginButton]);
  useEffect(() => {
    const defaultStandaloneHandsetTariff =
      state?.cart?.offers?.filter(
        obj => obj?.id === parseInt(getLocalStorage('HANDSET_BE_OFFERID'), 10)
      ).length === 1 &&
      state?.cart?.offers?.filter(obj => obj?.baseOffer?.serviceGroup === 'MOBILE').length === 1;
    if (cartCount > 0 && !defaultStandaloneHandsetTariff) {
      dispatch({ type: 'ENABLE_LOGIN_BUTTON', payload: false });
      setLocalStorageWithPrefix('ION_EXISTING_CUSTOMER', true);
    }
  }, [cartCount]);

  return (
    <Stack direction='row' alignItems='center'>
      {leftLink
        ? links?.SecondaryNavLeft?.Link?.map((data, i) => (
            <TopLink
              key={i}
              sx={{ textDecoration: 'none' }}
              href={data?.link}
              aria-label={data?.ariaLabel}
            >
              <Typography
                variant='body2'
                component='p'
                sx={{
                  ...styles,
                  color: theme.palette.primary.textColor3,
                  p: leftLink ? '8px 24px ' : 1,
                  background: leftLink && i === 0 ? theme.palette.secondary.contrastText : '',
                  '&:hover': {
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  },
                }}
              >
                {data.title}
              </Typography>
            </TopLink>
          ))
        : links?.SecondaryNavRight?.map((data, i) =>
            data?.Link?.map((nav, index) => (
              <TopLink
                key={index}
                sx={{ textDecoration: 'none' }}
                href={nav?.link}
                aria-label={nav?.ariaLabel}
              >
                <Stack
                  direction='row'
                  alignItems='center'
                  sx={{ mr: leftLink ? 1 : 0, pl: leftLink ? 0 : 3 }}
                  key={index}
                >
                  {data?.image && (
                    <Box
                      component='img'
                      alt=''
                      src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${data?.image?.data?.attributes?.url}`}
                    />
                  )}

                  <Typography
                    variant='body2'
                    component='p'
                    sx={{
                      color: theme.palette.primary.textColor3,
                      ...styles,
                      p: leftLink ? '8px 24px ' : 1,
                      background: leftLink && i === 0 ? theme.palette.secondary.contrastText : '',
                      '&:hover': {
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      },
                    }}
                  >
                    {nav?.title}
                  </Typography>
                </Stack>
              </TopLink>
            ))
          )}

      {!leftLink && state?.enableLogout && <EirLogOut key={state?.enableLogout} ctaText='Logout' />}
      {!leftLink && state?.loginButton && !state?.enableLogout && (
        <NotificationBanner
          cta={{
            ctaText: 'Log in to see deals',
            ariaLabel: 'Log in to see deals',
            type: 'solid',
            action: () => handleLogin(),
            disableCta: false,
          }}
        />
      )}
    </Stack>
  );
};

export default TopNavLink;
